export default "<h1>Hilfe</h1>\r\n"